<div class="profile-page">


  <h1>
    Merchant Profile
  </h1>




  <div class="profile-card">

    <div class="profile-pic-container" style="display: flex; align-items: center; gap: 30px; margin-bottom: 40px; padding-bottom: 30px; border-bottom: 1px solid #eee;">
      <img [src]="profilePicUrl || 'https://via.placeholder.com/150'" alt="Profile Picture"
        style="width: 120px; height: 120px; border-radius: 50%; object-fit: cover; border: 3px solid #e1e1e1; box-shadow: 0 4px 10px rgba(0,0,0,0.05);">
      <div>
        <h3 style="margin: 0 0 10px 0; font-size: 20px; color: #3b1c26;">Your Profile Picture</h3>
        <p style="margin: 0 0 15px 0; color: #6b7280; font-size: 14px;">Upload a professional picture for your business.</p>
        <input type="file" #fileInput (change)="onProfilePicChange($event)" style="display: none;" accept="image/*">
        <button type="button" (click)="fileInput.click()" style="background-color: transparent; border: 2px solid #B01E3E; color: #B01E3E; padding: 8px 16px; border-radius: 8px; font-weight: 600; cursor: pointer; transition: all 0.2s; display: flex; align-items: center; gap: 6px;" onmouseover="this.style.backgroundColor='#B01E3E'; this.style.color='white';" onmouseout="this.style.backgroundColor='transparent'; this.style.color='#B01E3E';">
          <span class="material-symbols-outlined" style="font-size: 18px;">upload</span>
          Change Profile Picture
        </button>
      </div>
    </div>


    <form [formGroup]="merchantForm" (ngSubmit)="updateProfile()">





      <h2>
        Basic Details
      </h2>



      <div class="form-grid">



        <div>

          <label>
            Business Name
          </label>


          <input type="text" formControlName="business_name">


        </div>





        <div>

          <label>
            Owner Name
          </label>


          <input type="text" formControlName="owner_name">


        </div>






        <div>

          <label>
            Category
          </label>

          <select formControlName="category">
            <option value="">Select Category</option>
            <option *ngFor="let cat of categories" [value]="cat._id">
              {{ cat.name }}
            </option>
          </select>

        </div>






        <div>

          <label>
            Phone
          </label>


          <input type="text" formControlName="phone">


        </div>



      </div>







      <h2>
        Business Address
      </h2>




      <div class="form-grid">



        <div>

          <label>
            Address Line 1
          </label>


          <input type="text" formControlName="address_line1">


        </div>





        <div>

          <label>
            Area / Locality
          </label>


          <input type="text" formControlName="area">


        </div>






        <div>
          <label>State</label>
          <select formControlName="state">
            <option value="">Select State</option>
            <option *ngFor="let state of states" [value]="state._id">
              {{state.name_1}}
            </option>
          </select>
        </div>

        <div>
          <label>District</label>
          <select formControlName="district">
            <option value="">Select District</option>
            <option *ngFor="let district of districts" [value]="district._id">
              {{district.name_2}}
            </option>
          </select>
        </div>

        <div>
          <label>City</label>
          <select formControlName="city">
            <option value="">Select City</option>
            <option *ngFor="let city of cities" [value]="city._id">
              {{city.city_nme}}
            </option>
          </select>
        </div>

        <div>
          <label>Pincode</label>
          <input type="text" maxlength="6" formControlName="pincode">
        </div>



      </div>












      <button type="submit" style="background-color: #B01E3E; color: white; padding: 12px 24px; border: none; border-radius: 8px; font-size: 16px; font-weight: 600; cursor: pointer; margin-top: 30px; display: flex; align-items: center; justify-content: center; gap: 8px; transition: background-color 0.2s; min-width: 180px;" onmouseover="this.style.backgroundColor='#8e1732'" onmouseout="this.style.backgroundColor='#B01E3E'">
        <span class="material-symbols-outlined" *ngIf="!loading">save</span>
        {{loading ? 'Updating...' : 'Save Changes'}}
      </button>




    </form>


  </div>


</div>